module.exports = require("./de-CH");